import { Component, OnInit, OnDestroy } from '@angular/core';
import { Seller } from '../../../models/seller';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminSellerService } from '../admin-seller.service';
import { EconomicGroup } from '../../../models/economic-group';
import { AdminEconomicGroupService } from '../../admin-economic-groups/admin-economic-group.service';

@Component({
  selector: 'app-seller-form',
  templateUrl: './seller-form.component.html',
  styleUrls: ['./seller-form.component.scss']
})
export class SellerFormComponent implements OnInit, OnDestroy {
  private sub: any;
  seller: Seller = new Seller();
  sellerForm: FormGroup;
  economicGroups: EconomicGroup[] = [];

  constructor(
    public fb: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    private adminSellerService: AdminSellerService,
    private adminEconomicGroupService: AdminEconomicGroupService,
  ) {
    this.adminEconomicGroupService.getAll().subscribe((economicGroups) => {
      this.economicGroups = economicGroups;
    });
  }

  reactiveForm() {
    this.sellerForm = this.fb.group({
      name: ['', [Validators.required]],
      cpfCnpj: ['', [Validators.required]],
      email: ['', [Validators.required]],
      externalId: ['', [Validators.required]],
      whatsapp: ['', []],
      skype: ['', []],
      phone: ['', []],
      economicGroupId: ['', [Validators.required]],
    });
  }

  public errorHandling = (control: string, error: string) => {
    return this.sellerForm.controls[control].hasError(error);
  }

  async submitForm() {
    const formData = this.sellerForm.value;

    try {
      if (this.seller.id) {
        this.adminSellerService
          .updateSeller(this.seller.id, Object.assign(this.seller, formData))
          .subscribe((seller) => {
            if (seller.affected) {
              this.router.navigate(['/admin/sellers']);
            }
          });
      } else {
        this.adminSellerService
          .createSeller(formData)
          .subscribe((seller) => {
            if (seller.id) {
              this.router.navigate(['/admin/sellers']);
            }
          });
      }
    } catch (error) {
      console.log(error);
    }
  }

  updateFormValues(seller: Seller) {
    this.sellerForm.patchValue(seller);
  }

  ngOnInit(): void {
    this.sub = this.route.params.subscribe(params => {
      if (params.id) {
        this.adminSellerService.getSeller(+params.id).subscribe((seller) => {
          this.seller = seller;

          this.updateFormValues(seller);
        });
      }
    });

    this.reactiveForm();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
